/* eslint-disable no-restricted-globals */
import { dwmRepository } from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _serviceDependencies = ['$scope', '$http', '$rootScope', 'Util', 'dwmValidations'];

class DwmGamerTags {

    constructor($scope, $http, $rootScope, Util, dwmValidations) {


        $scope.tagIsValid = true;
        const validations = dwmValidations;

        const onDwmDataNext = () => {

            const assets = dwmRepository.getAll('assets') || {};
            if (assets.primaryMember) {

                $scope.gamerTags = assets.primaryMember.monitoredAccounts.gamerTags;

                $scope.gamerTags.entries.forEach((entry) => {

                    entry.showUpdateInput = false;

                });

            }

        };

        const dwmRepositoryObservable = dwmRepository.getObservable();
        dwmRepositoryObservable
            .subscribe(
                data => onDwmDataNext(data),
                () => { },
                () => { },
            );

        $scope.newEntryVisible = false;
        $scope.showAddNewButton = true;
        $scope.showSaveButton = false;
        $scope.showRemoveEntryScreen = false;
        $scope.showUpdateButton = false;

        $scope.addNewEntry = () => {

            $scope.newEntryVisible = true;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = true;
            setTimeout(() => {

                angular.element('#tag').focus();

            }, 100);

        };

        $scope.cancelNewEntry = () => {

            $scope.tagIsValid = true;
            $scope.newEntryVisible = false;
            $scope.showAddNewButton = true;
            $scope.showSaveButton = false;
            $scope.newGamerTag = '';
            $scope.newEntrySubmitted = false;

        };

        $scope.updateEntry = (index) => {

            $scope.newEntryVisible = false;
            $scope.showAddNewButton = false;
            $scope.showSaveButton = false;
            $scope.showUpdateButton = true;

            $scope.gamerTags.entries.forEach((entry, loopIndex) => {

                if (index === loopIndex) {

                    entry.showUpdateInput = true;
                    const newEntry = { ...entry };
                    $scope.updateEntryPayload = newEntry;

                } else {

                    entry.showUpdateInput = false;

                }

            });

            setTimeout(() => {

                angular.element('.update-tag').focus();

            }, 100);

        };

        $scope.cancelUpdateNewEntry = () => {

            $scope.tagIsValid = true;
            $scope.showAddNewButton = true;
            $scope.showUpdateButton = false;

            $scope.gamerTags.entries.forEach((entry) => {

                entry.showUpdateInput = false;

            });

            $scope.updateEntryPayload = {};

        };

        $scope.validateTag = ($event) => {

            if ($scope.newEntrySubmitted) {

                $scope.tagIsValid = validations.gamerTagValidator($event.currentTarget.value);

            }

            $scope.newGamerTag = $event.currentTarget.value;

        };

        $scope.saveNewEntry = () => {

            $scope.tagIsValid = validations.gamerTagValidator($scope.newGamerTag);

            $scope.newEntrySubmitted = true;

            if ($scope.tagIsValid) {

                $scope.savenewGamerTagIsLoading = true;

                const payload = {
                    gamerTags: {
                        tag: $scope.newGamerTag,
                    },
                };

                $http({
                    method: 'POST',
                    url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },
                    data: payload,

                }).then(() => {

                    $scope.newGamerTag = '';
                    $scope.savenewGamerTagIsLoading = false;

                    $http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: $rootScope.dwmNortonToken,
                            'Content-Type': 'application/json',
                        },

                    }).then((membersResponse) => {

                        dwmRepository.replace('assets', membersResponse.data);

                        const { monitoredAccounts, dwmCardStatus } =
                            membersResponse.data.primaryMember;

                        Mixpanel.setCommonProperty('AIA Asset Gamer Tag', monitoredAccounts.gamerTags.entries.length);

                        Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                            Action: 'Add',
                            Entry: 'Gamer tag',
                        });

                        if (dwmCardStatus === 'add-more-data') {

                            $rootScope.showDwmCardHomepage = true;
                            $rootScope.showDwmAddMoreDataCard = true;

                        } else {

                            $rootScope.showDwmCardHomepage = false;

                        }

                        $scope.cancelNewEntry();

                    });

                }).catch((responseError) => {

                    $scope.savenewGamerTagIsLoading = false;

                    if (responseError.data) {

                        if (responseError.data.errorCode === 4013) {

                            Alert.error('cw.dwm.dupliacte_entry_error');

                        } else {

                            Alert.error(
                                { message: 'cw.recommendation.error.connection_failed' },
                                {
                                    message: {
                                        brandname: CWCONFIG.partnerConfig.name,
                                        url: '/dashboard/support/tabs/support',
                                    },
                                },
                            );

                        }

                    }

                });

            }

        };

        $scope.removeEntry = (index) => {

            $scope.showRemoveEntryScreen = true;
            $scope.cancelNewEntry();

            $scope.removeEntryPayload = {
                gamerTags:
                {
                    id: $scope.gamerTags.entries[index].id,
                },
            };

        };

        $scope.confirmRemoveEntry = () => {

            $scope.confirmRemoveIsLoading = true;

            $http({
                method: 'DELETE',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount?payload=${encodeURIComponent(JSON.stringify($scope.removeEntryPayload))}`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
            }).then(() => {

                $scope.newGamerTag = '';
                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);

                    const { monitoredAccounts, dwmCardStatus } = membersResponse.data.primaryMember;
                    Mixpanel.setCommonProperty('AIA Asset Gamer Tag', monitoredAccounts.gamerTags.entries.length);

                    Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                        Action: 'Delete',
                        Entry: 'Gamer tag',
                    });

                    if (dwmCardStatus === 'add-more-data') {

                        $rootScope.showDwmCardHomepage = true;
                        $rootScope.showDwmAddMoreDataCard = true;

                    } else {

                        $rootScope.showDwmCardHomepage = false;

                    }

                    $scope.showUpdateButton = false;
                    $scope.showAddNewButton = true;
                    $scope.confirmRemoveIsLoading = false;
                    $scope.cancelRemoveEntry();
                    $scope.cancelUpdateNewEntry();

                });

            }).catch((responseError) => {

                $scope.confirmRemoveIsLoading = false;

                if (responseError.data) {

                    Alert.error(
                        { message: 'cw.recommendation.error.connection_failed' },
                        {
                            message: {
                                brandname: CWCONFIG.partnerConfig.name,
                                url: '/dashboard/support/tabs/support',
                            },
                        },
                    );

                }

            });

        };

        $scope.cancelRemoveEntry = () => {

            $scope.showRemoveEntryScreen = false;
            $scope.removeEntryPayload = {};

        };

        $scope.entryUpdateValue = ($event) => {

            $scope.tagIsValid = validations.gamerTagValidator($event.currentTarget.value);

            if ($scope.tagIsValid) {

                $scope.updateEntryPayload.tag = $event.currentTarget.value;

            }

        };

        $scope.saveUpdatedEntry = () => {

            $scope.saveUpdatedEntryIsLoading = true;

            $http({
                method: 'PUT',
                url: `${CWCONFIG.dwm.restApi}/v1/modifyAccount`,
                headers: {
                    client_id: 'avira',
                    origin: 'https://avira.com',
                    access_token: $rootScope.dwmNortonToken,
                    'Content-Type': 'application/json',
                },
                data: {
                    gamerTags: {
                        tag: $scope.updateEntryPayload.tag,
                        id: $scope.updateEntryPayload.id,
                    },
                },
            }).then(() => {

                Mixpanel.send('ConnectWeb AIA Entry Action Success', {
                    Action: 'Update',
                    Entry: 'Gamer tag',
                });

                $scope.showAddNewButton = true;
                $scope.showUpdateButton = false;
                $scope.updateEntryPayload = {};
                $scope.saveUpdatedEntryIsLoading = false;

                $http({
                    method: 'GET',
                    url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        access_token: $rootScope.dwmNortonToken,
                        'Content-Type': 'application/json',
                    },

                }).then((membersResponse) => {

                    dwmRepository.replace('assets', membersResponse.data);
                    $scope.confirmRemoveIsLoading = false;

                });

            }).catch((responseError) => {

                $scope.saveUpdatedEntryIsLoading = false;

                if (responseError.data) {

                    if (responseError.data.errorCode === 4013) {

                        Alert.error('cw.dwm.dupliacte_entry_error');

                    } else {

                        Alert.error(
                            { message: 'cw.recommendation.error.connection_failed' },
                            {
                                message: {
                                    brandname: CWCONFIG.partnerConfig.name,
                                    url: '/dashboard/support/tabs/support',
                                },
                            },
                        );

                    }

                }

                $scope.gamerTags.entries.forEach((entry) => {

                    entry.showUpdateInput = false;

                });

                $scope.updateEntryPayload = {};
                $scope.saveUpdatedEntryIsLoading = false;

            });

        };

    }

}

_serviceDependencies.push(DwmGamerTags);

angular.module('controllers')
    .controller('DwmGamerTags', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/modals/dwm/gamer-tags/gamer-tags.js